import BrandItemAdmin from './BrandItemAdmin';

export default BrandItemAdmin;
